export const LEMON_SQUEEZY_BASE_URL = 'https://basket-premium.lemonsqueezy.com/buy';
export const EXCHANGE_RATE_API_KEY = '40e062924ae69a6f48d7132b';

export const PRICING_TIERS = [
  {
    period: '3 months',
    price: 16,
    perMonth: 5.33,
    savings: null,
    recommendation: 'Perfect for short-term study goals with less than 5 subjects',
    productId: process.env.REACT_APP_THREE_MONTH_PLAN_ID
  },
  {
    period: '6 months',
    price: 26.50,
    perMonth: 4.42,
    savings: '17%',
    label: 'Recommended',
    recommendation: 'Best for most students with 5+ subjects',
    productId: process.env.REACT_APP_SIX_MONTH_PLAN_ID
  },
  {
    period: 'annual',
    price: 42.50,
    perMonth: 3.54,
    savings: '33%',
    label: 'Best Value',
    recommendation: 'Ideal if you want to take your time and save the most',
    productId: process.env.REACT_APP_ANNUAL_PLAN_ID
  }
];